import { UseQueryOptions } from "@tanstack/react-query"
import { AxiosError } from "axios"

import {
  paradiseLLMPromptsKeys,
  useParadiseLLMPromptsCache,
} from "src/data/paradise/paradiseLLMPrompts/queries/paradiseLLMPromptsQueryCache"
import { TParadiseLLMPromptsQueryParams } from "src/data/paradise/paradiseLLMPrompts/types/paradiseLLMPromptsQueryTypes"
import { TParadiseLLMPromptsResponse } from "src/data/paradise/paradiseLLMPrompts/types/paradiseLLMPromptsQueryTypes"
import { useMinutPost, useMinutQuery } from "src/hooks/minutQuery"

export function useFetchParadiseLLMPrompts({
  filter,
  options,
}: {
  filter: TParadiseLLMPromptsQueryParams
  options?: UseQueryOptions<
    TParadiseLLMPromptsResponse,
    AxiosError,
    TParadiseLLMPromptsResponse,
    ReturnType<typeof paradiseLLMPromptsKeys.promptsList>
  >
}) {
  return useMinutQuery({
    queryKey: paradiseLLMPromptsKeys.promptsList(filter),
    queryPath: `/llm-prompts`,
    ...options,
  })
}

export function usePostParadiseLLMPrompt() {
  const paradiseLLMPromptsCache = useParadiseLLMPromptsCache()

  return useMinutPost<"/llm-prompts">({
    apiPath: "/llm-prompts",
    pathFn: () => "/llm-prompts",
    options: {
      onSuccess: () => {
        return paradiseLLMPromptsCache.invalidateParadiseLLMPromptsList()
      },
    },
  })
}
